export default {"src":"/_next/static/media/lc.e5420a92.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};